import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '../Box/index.js';
import 'react';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { getRangePercent } from './utils/getRangePercent/getRangePercent.js';

var ProgressBar = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? "right" : _b, _c = _a.value, value = _c === void 0 ? 0 : _c, _d = _a.minValue, minValue = _d === void 0 ? 0 : _d, _e = _a.maxValue, maxValue = _e === void 0 ? 100 : _e, label = _a.label, labelledBy = _a.labelledBy, describedBy = _a.describedBy, props = __rest(_a, ["direction", "value", "minValue", "maxValue", "label", "labelledBy", "describedBy"]);
    // if neither label or labelledBy are set, use the value as the label
    if (process.env.NODE_ENV === "development" && !(label || labelledBy)) {
        console.warn("ProgressBar requires either a `label` or `labelledBy` value");
    }
    var handleStyleProps = useTheme().handleStyleProps;
    var _f = handleStyleProps(props, {
        themeKey: "progressBar",
    }), css = _f.css, forwardProps = __rest(_f, ["css"]);
    // calculate progress as percentage of the range between 0% and 100%
    var progress = getRangePercent(value, minValue, maxValue);
    // extract colours from shared style
    var color = css.color, backgroundColor = css.backgroundColor, barCss = __rest(css, ["color", "backgroundColor"]);
    // use `color` for the progress indicator
    var indicatorCss = __assign({ backgroundColor: color }, barCss);
    // use `backgroundColor` for the background
    var bgCss = __assign({ backgroundColor: backgroundColor }, barCss);
    return (jsx(Box, __assign({ role: "progressbar", "aria-valuemin": minValue, "aria-valuemax": maxValue, "aria-valuenow": value, "aria-label": label, "aria-labelledby": labelledBy, "aria-describedby": describedBy, sx: bgCss }, forwardProps, { children: jsx(Box, { sx: indicatorCss, style: {
                position: "absolute",
                left: direction === "left" ? "".concat(100 - progress, "%") : undefined,
                width: "".concat(progress, "%"),
            } }) })));
};

export { ProgressBar };
//# sourceMappingURL=ProgressBar.js.map
